import { WhitelabelConfig } from '@whitelabel/types';

const RocketmilesWhitelabelConfig: WhitelabelConfig = {
    displayName: 'Rocketmiles',
};

export default RocketmilesWhitelabelConfig;
